<template style="height: 100%;">
  <div class="Alreadytest CommonContentSingle-gray">
    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);min-height: 220px;height: auto;">
        <div v-bind:class="[isActive ? activeClass : errorClass]">

          <el-form :inline="true" :model="formInline">
            <el-form-item :label="$t('original.languages110')">
              <el-input v-model="formInline.searchData" :placeholder="$t('original.languages111')"></el-input>
            </el-form-item>
<!-- 
            <el-form-item :label="$t('original.account')">
              <el-input
                v-model="formInline.Student"
                :placeholder="$t('original.account')"
              ></el-input>
            </el-form-item> -->



            <el-form-item :label="$t('original.Name_of_scale')">
              <el-input v-model="formInline.ScaleName" :placeholder="$t('original.Name_of_scale')"></el-input>
            </el-form-item>

            <el-form-item :label="$t('original.languages170')">
              <el-date-picker v-model="formInline.TestTime" unlink-panels style="height:38px" type="daterange" value-format="yyyy-MM-dd"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              <!-- <el-date-picker  type="daterange"  @change="chooseTimeRange"  value-format="yyyy-MM-dd" v-model="times"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker> -->
            </el-form-item>

            <el-form-item :label="$t('original.Release_theme')">
              <el-select  @change="schange"  v-model="formInline.PublishID" :placeholder="$t('original.languages3')">
                <el-option v-for="item in GetScaleIssue" :key="item.PublishID" :label="item.PublishSubject" :value="item.PublishID"></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="发布对象">
              <el-input v-model="formInline.ObjectS" placeholder="发布对象"></el-input>
            </el-form-item> -->

            <el-form-item :label="$t('original.Release_object')">
              <el-select v-model="formInline.ObjectS" filterable :placeholder="$t('original.Release_object')">
                <el-option v-for="item in Obj" :key="item.id" :label="item.DeptName" :value="item.DeptID"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="rux" label="入学年份">
              <!-- <el-date-picker v-model="formInline.StudyTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker> -->

              <el-select v-model="formInline.StudyTime" :placeholder="$t('original.languages3')">
                <el-option v-for="item in nianji" :key="item.dicKey" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            
              <el-form-item class="cvde" :label="$t('original.languages144')">
                <div style="display: flex">
                  <div style="margin-right: 20px">
                    <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
                       {{ $t('original.languages155') }}
                    </el-checkbox>
                  </div>
                  <el-checkbox-group v-model="formInline.Warning"  @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(item, index) in statusTree" :key="index" :value="item.id"  :label="item.id">
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>

                </div>
              </el-form-item>
              <br>
            <!-- <div v-show="isActive">
              </div> -->
            <el-form-item class="cvbb" style="width: 260px">
              <el-button type="primary" @click="onSubmit">{{ $t('original.screening') }}</el-button>
              <el-button type="primary" @click="onSubmits">{{ $t('original.reset') }}</el-button>
            </el-form-item>
            <!-- <div class="change" @click="change">打开</div> -->
          </el-form>
        </div>
      </el-header>

      <el-main style="margin-top: 15px;background: rgba(255, 255, 255, 1)"  class="el-Content">
        <el-button type="primary" @click="handleClick"> {{ $t('original.Export_all') }}</el-button>
        <el-button type="primary" @click.native="testexport(1)">{{ $t('original.Export_the_selected') }}</el-button>
        <el-button type="primary" @click.native="testexport(2)">批量打印</el-button>
        <el-button type="primary" @click="dels"> {{ $t('original.Batch_delete') }}</el-button>
        <div class="talies">

          <el-table  ref="multipleTable"  v-loading="wloadings" @selection-change="handleSelectionChange" :row-key="(row) => {  return row.PaperResultID;}" :data="tableData"  style="width: 100%; margin-top: 10px" :default-sort="{ prop: 'date', order: 'descending' }">
            <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true"  width="55"></el-table-column>

            <el-table-column :label="$t('original.The_serial_number')" width="60px" align="left">
              <template slot-scope="scope" center>
                {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.Name_of_scale')" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.PaperName }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.account')">
              <template slot-scope="scope">
                <span>{{ scope.row.UserID }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.name')">
              <template slot-scope="scope">
                <span>{{ scope.row.RealName }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages106')">
              <template slot-scope="scope">
                <span>{{ scope.row.PaperScoreR }}</span>
              </template>
            </el-table-column>
        
            <el-table-column :label="$t('original.languages107')">
              <template slot-scope="scope">
                <span>{{ scope.row.PaperScoreS }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages144')" :formatter="getPartnerName">
              <template slot-scope="scope">

                <i v-if="scope.row.WarningID == '正常'" class="sssvd">
                  <span>{{ scope.row.WarningID }}</span>
                </i>

                <i v-else-if="scope.row.WarningID == '轻度'" class="sssvd2">
                  <span>{{ scope.row.WarningID }}</span>
                </i>

                <i v-else-if="scope.row.WarningID == '中度'" class="sssvd3">
                  <span>{{ scope.row.WarningID }}</span>
                </i>

                <i v-else-if="scope.row.WarningID == '较重'" class="sssvd4">
                  <span>{{scope.row.WarningID}}</span>
                </i>

                <i v-else-if="scope.row.WarningID == '重度'" class="sssvd5">
                  <span>{{scope.row.WarningID}}</span>
                </i>

              </template>
            </el-table-column>

            <el-table-column label="测试时间" width="180" align="center">
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top">
                  <p>测试时间: {{ scope.row.EndTime }}</p>
                  <div slot="reference" class="name-wrapper">
                    <span style="margin-left: 10px">
                      {{scope.row.EndTime}}
                    </span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages152')">
              <template slot-scope="scope">
                <span>{{scope.row.SeTime }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages147')">
              <template slot-scope="scope">
                <span>{{scope.row.IsSubmit}}</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" :label="$t('original.languages49')" width="100">
              <template v-if="scope.row.IsSubmit == '已生成报告'"  slot-scope="scope">
                <el-button  @click="handleClicks(scope.row)"  type="text" size="small">
                   {{ $t('original.languages73') }}
                </el-button>
                <el-button type="text" @click="open(scope.row)" size="small">
                   {{ $t('original.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block" v-if="tableData.length > 0">
            <el-pagination  @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10"  layout="total, prev, pager, next"  :total="Counts"></el-pagination>
          </div>

        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Notest from "./Notest";
export default {
  data() {
    return {
      pageIndexs: 1,
      ccfd: true,
      wloadings: true,
      Counts: 0,
      isIndeterminate: false,
      checkAll: false,
      ceshishij: false,
      Obj: [],
      del: [], //删除的数据
      GetScaleIssue: [],
      currentPage1: 1,
      statusTree: [
        {id: "重度",label: "重度"},
        {id: "较重",label: "较重"},
        {id: "中度",label: "中度"},
        {id: "轻度",label: "轻度"},
        {id: "正常",label: "正常"},
      ],
      panduan: [1, 1, 1, 1],
      activeNames: ["1"],
      activeName: "second",
      input1: "",
      value1: "",
      isActive: true,
      activeClass: "Nac",
      errorClass: "Nac2",
      PaperResultID: [],
      formInline: {
        Name: "",
        Student: "",
        ScaleName: "",
        TestTime: "",
        PublishID: "",
        ObjectS: "",
        StudyTime: "",
        Warning: [],
        searchData: "",
      },
      nianji: [],
      tableData: [],
      checkboxGroup1: [],
    };
  },
  components: {
    Notest,
  },
  methods: {
    handleChange(val) {

    },
    checkSelectable(row, index) {
      if (row.IsSubmit == "已生成报告") {
        return true;
      } else {
        return false;
      }
    },
    change() {
      this.isActive = !this.isActive;
    },
    onSubmit() {
      this.loading(1, 0);
      this.currentPage1 = 1;
    },
    handleClick() {
      this.$Http_Post("ScaleIssue/GetScaleMeasured",{pageSize: "10",pageIndex: "1",Nation: "",Sex: "",Study: "",IfS: "1",Language: "Chinese",from: this.formInline,IfSPublishID: ["0"]}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (res.Data == "无此文件") {
            this.Global.request_failure(this.$t('original.languages148'));
          } else if (res.Data == "无需要导出的文件") {
            this.Global.request_failure(this.$t('original.languages149'));
          } else {
            this.Global.request_successful(res.Message);
            window.location = res.Data;
          }
        } else if (res.Code == 299) {
          this.Global.request_failure(res.Message);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleClicks(a, b) {//报告
      let routeData = this.$router.resolve({
        path: "/visitors/ReportShow",
        query: { PaperResultID: a.PaperResultID},
      });
      window.open(routeData.href, "_blank");
    },
    onSubmits() {
      this.formInline.Name = "";
      this.formInline.searchData = "";
      this.formInline.Student = "";
      this.formInline.ScaleName = "";
      this.formInline.TestTime = "";
      this.formInline.PublishID = "";
      this.formInline.ObjectS = "";
      this.formInline.StudyTime = "";
      this.formInline.Warning = [];
      this.isIndeterminate = false;
      this.checkAll = false;
      this.loading(1, 0);
      this.currentPage1 = 1;
    },
    handleCheckAllChange(val) {
      const all = this.statusTree.map((item) => {
        return item.id;
      });
      this.formInline.Warning = val ? all : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.statusTree.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.statusTree.length;
    },
    onSubmitout() {
      this.$Http_Post("ScaleIssue/GetScaleMeasured",{ pageSize: "10", pageIndex: 1, Nation: "", Sex: "", Study: "", Language: "Chinese", from: this.formInline, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location = res.Data;
        }
      })
    },
    testexport(val) {
      
      let routeData = this.$router.resolve({
        path: "/visitors/ReportShow",
        query: { PaperResultID: '0',PaperResultIDlist:this.PaperResultID },
      });

      window.open(routeData.href, "_blank");

      // this.$Http_Post("ScaleIssue/GetScaleMeasured",{
      //   pageSize: "10",
      //   pageIndex: "1",
      //   Nation: "",
      //   Sex: "",
      //   Study: "",
      //   IfS: "1",
      //   Language: "Chinese",
      //   from: this.formInline,
      //   IfS: val,
      //   IfSPublishID: this.PaperResultID.length >= 1 ? this.PaperResultID : (this.PaperResultID = ["1"])
      // }).then((res) => {
      //   if (res.Code == 200 || res.Code == 0) {
      //     if (res.Data == "无此文件") {
      //       this.Global.request_failure(this.$t('original.languages148'));
      //     } else if (res.Data == "无需要导出的文件") {
      //       this.Global.request_failure(this.$t('original.languages149'));
      //     } else {
      //       this.Global.request_successful(res.Message);
      //       window.location = res.Data;
      //     }
      //   } else if (res.Code == 299) {
      //     this.Global.request_failure(res.Message);
      //   } else {
      //     this.Global.request_failure(res.Message);
      //   }
      // })
    },
    handleEdit(index, row) {},
    handleDelete(index, row) {},
    handleCurrentChange(val) {this.loading(val,0)},
    loading(num, DeriveText) {
      this.pageIndexs = num;
      this.$Http_Post("ScaleIssue/GetScaleMeasured",{pageSize: "10",pageIndex: num,Nation: "",Sex: "",Study: "",IfS: DeriveText,Language: "Chinese",from: this.formInline,IfSPublishID: ""}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
          this.wloadings = false;
        } else {
          this.wloadings = false;
        }
      })
    },
    schange(val) {
      this.Obj = "";
      this.formInline.ObjectS = "";
      this.$Http_Post("ScaleIssue/GetCommonReturnDataTheme",{ PublishID: val }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Obj = res.Data;
        }
      })
    },
    open(val) {
      this.$confirm(this.$t('original.languages150'), this.$t('original.languages63'), { confirmButtonText: this.$t('original.languages59'), cancelButtonText: this.$t('original.cancel'),type: "warning",}).then(() => {
        this.wloadings = true;
        var cs = [val.PaperResultID]
        this.$Http_Post("ScaleIssue/DePaperresult", //获取发布对象
          { PaperResultID:  cs }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.wloadings = false;
              this.$message({
                type: "success",
                message: res.Message,
              });
              this.loading(1, 0);
            } else {
              this.wloadings = false;
              this.$message({type: "info",message: res.Message,});
            }
          })
        })
    },
    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].PaperResultID);
      }
      this.PaperResultID = lsc;
    },
    getPartnerName(row, col) {},

    dels() {
      this.$confirm(this.$t('original.languages150'), this.$t('original.languages63'), { confirmButtonText: this.$t('original.languages59'), cancelButtonText: this.$t('original.cancel'),type: "warning"}).then(() => {
        this.wloadings = true;
        this.$Http_Post("ScaleIssue/DePaperresult",{ PaperResultID: this.PaperResultID } ).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.$message({
              type: "success",
              message: res.Message,
            });
            this.loading(1, 0);
            this.$refs.multipleTable.clearSelection();
          } else {
            this.$message({
              type: "info",
              message: res.Message,
            });
          }
        })
      })
    },
  },
  mounted() {
    this.loading(1, 0);
    this.$Http_Post("ScaleIssue/GetScaleIssue",{ pageSize: "200", pageIndex: 1, PublishSubject: "", Condition: "" }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetScaleIssue = res.Data;
        this.formInline.PublishID = res.Data[0].PublishID;
        this.schange(this.formInline.PublishID)
      }
    });


    this.$Http_Post("User/GetDictionaryList",{ DicTypCode: "1"}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.nianji = res.Data
      }
    });



  },
};
</script>
<style>
.Alreadytest .el-tabs__nav-scroll {
  border: 1px solid #e3e3e3;
  padding-left: 16px;
}
.Alreadytest .el-tabs__header {
  margin: 0 0 0px;
}
input {
  width: 300px;
}
.Alreadytest .el-form--inline .el-form-item {
  width: 31.5%;
}
.Alreadytest .el-form-item__content {
  width: 75%;
}
.Alreadytest .el-form-item__label {
  width: 70px;
  text-align: right;
}
.Alreadytest .el-date-editor {
  width: 100%;
}
.Alreadytest .cvde {
  width: 60% !important;
}
.Alreadytest .Nac {
  height: 180px;
  position: relative;
  border: 0px;
}
.Nac2 {
  height: 300px;
  position: relative;
  border: 1px solid #e3e3e3;
  padding-top: 20px;
  padding: 16px;
}
.change {
  width: 40px;
  margin-left: -80px;
  display: inline-block;
  height: 22px;
  margin-top: 22px;
  position: absolute;
  z-index: 10;
  cursor: pointer;
  color: #5e5a5a;
}
.Alreadytest .cvbb {
  margin-bottom: 30px;
}
.Alreadytest .Thelist {
  background-color: #fff;
}
.el-tooltip__popper {
  max-width: 20%;
}
.el-tooltip__popper,.el-tooltip__popper.is-dark {
  background: #f5f5f5 !important;
  color: #303133 !important;
}
.Alreadytest .block {
  float: right;
  margin-top: 20px;
}
.Alreadytest .el-select {
  width: 100% !important;
}
.sssvd {
  display: inline-block;
  width: 56px;
  height: 24px;
  background-color: #3ac282;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
}
.sssvd2 {
  display: inline-block;
  width: 56px;
  height: 24px;
  background-color: #7ec24a;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
}
.sssvd3 {
  display: inline-block;
  width: 56px;
  height: 24px;
  background-color: #ffc400;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
}
.sssvd4 {
  display: inline-block;
  width: 56px;
  height: 24px;
  background-color: #f02b2e;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
}
.sssvd5 {
  display: inline-block;
  width: 56px;
  height: 24px;
  background-color: #ad0003;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  font-size: 14px;
  color: #fff;
}

.Alreadytest .Thelist {
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: scroll;
}
.Alreadytest .Thelist::-webkit-scrollbar {
  display: none;
}
.Alreadytest .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 36px;
  line-height: 36px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.Alreadytest .el-date-editor .el-range-input {
  height: 20px;
}
.Alreadytest .el-form-item {
  margin-bottom: 6px;
}
.talies {
  width: 100%;
}
.rux ::-webkit-input-placeholder {
  /* WebKit browsers */
  padding-left: 14px;
}
.rux input {
  padding-left: 30px;
}

.Alreadytest .el-table .cell {
  text-align: center;
}
.uhugfyhml {
  background-color: #3ac282;
}
</style>
